<template>
  <div class="k-onboarding__quest-wrapper">
    <div class="k-onboarding__quest">
      <div class="k-onboarding__weight-label">
        <label for="onbording_weight">Укажите ваш вес:</label>
      </div>
      <div class="k-onboarding__weight-input-wrapper">
        <input
          class="k-onboarding__input k-onboarding__weight-input jq-onboarding-input number-no-controls"
          type="number"
          placeholder="60"
          title="Рост"
          id="onbording_weight"
          v-model="weight"
          v-focus
        />
      </div>
      <div class="error-message" v-if="hasError">
        Ошибка при создании профиля.
        <br />Проверьте данные и попробуйте ещё раз
      </div>
      <a
        href="#"
        @click.prevent="processSubmit"
        :class="['k-onboarding__quest-next', { active: validWeight }]"
      >Далее</a>
      <slot />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "OnboardingWeight",
  props: {
    editProfile: Object,
  },
  data() {
    return {
      hasError: false
    };
  },
  computed: {
    weight: {
      get() {
        if (this.editProfile) return this.editProfile.weight;
        return this.$store.getters.getProfileWeight;
      },
      set(value) {
         if (!this.editProfile) {
          this.$store.dispatch("setProfileData", { weight: value });
        } else {
          this.editProfile.weight = value;
        }
      }
    },
    validWeight() {
      return this.weight && !isNaN(this.weight);
    },
    currentCreatedProfile() {
      return this.$store.getters.getUserFamily.find(el => el.is_main === 't')
    }
  },
  mounted() {
    this.hasError = false;
  },
  methods: {
    ...mapActions([
      'updateProfile'
    ]),
     async processSubmit() {
      if (this.validWeight) {
        if (this.currentCreatedProfile && !this.editProfile) {
          await this.updateProfile({
            id: this.currentCreatedProfile.id,
            weight: this.weight,
          })
        }
        this.$router.push({ name: "OnboardingActivity" });
      }
    }
  }
};
</script>

<style scoped>
</style>
